/**
 * Turn single newlines into markdown hard line breaks so CMS-authored copy behaves the way
 * editors expect (a single Enter = a line break), matching the designs — e.g. a bold lead-in
 * on its own line above the description inside a list item.
 *
 * Paragraph breaks (blank lines) are left untouched.
 */
export function withHardBreaks(markdown: string): string {
    return markdown.replace(/\r\n/g, "\n").replace(/([^\n])\n(?!\n)/g, "$1  \n");
}
